import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createClient } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};
  console.log(values);
  return {
    ...Object.fromEntries(
      Object.entries(values).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useCreateClient() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      const response = await createClient({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Client Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
